import axios from 'axios';
import { API_URL } from '../config/constants';

export const receiptError = (error) => {
    return {
        type: 'RECEIPT_ERROR',
        error
    };
};

export const emailReceiptSuccess = () => {
    return {
        type: 'RECEIPT_DELIVERED'
    }
};

export const receiptLoading = () => {
    return {
        type: 'RECEIPT_LOADING'
    };
};

export const updateOrderTagged = (order_id, tagged, orderHistory) => {

    return {
        type: 'UPDATE_ORDER_TAGGED',
        order_id,
        tagged,
        orderHistory
    };
};

export const trackTaggedStatus = (orderTagStatus) => {
    return {
        type: 'CURRENT_TAG',
        orderTagStatus
    };
}

export const receiptComplete = () => {
    return {
        type: 'RECEIPT_COMPLETE'
    };
};

export const toggleOrderTagged = (id, tagged, token, orderHistory) => {
    return (dispatch) => {

        // provide the order id
        let params = {
            token: token,
            oid: id,
            tagged,
        };

        let curToggleActionText = tagged ? 'untag': 'tag';

        // attempt to reach the server
        axios.get(API_URL+'/api/order/toggleTagged', { params })
            .then(function(res) {
                if (res.data.status == "success") {
                    dispatch(trackTaggedStatus(+!params.tagged));
                    dispatch(updateOrderTagged(params.oid, +!params.tagged, orderHistory));
                    dispatch(receiptComplete());
                }
                else {
                    setTimeout(() => {
                        alert("We're sorry, but we were unable to "+curToggleActionText+" your order. Please try again in a moment or contact support if the issue persists.");
                    }, 100);
                }
            })
            .catch(function(err) {
                console.log(err);
                setTimeout(() => {
                    alert("We're sorry, but we were unable to "+curToggleActionText+" your order. Please try again in a moment or contact support if the issue persists.");
                }, 100);
                dispatch(receiptComplete());
            });
    };
}

export const requestEmailReceipt = (params) => {
    return (dispatch) => {

        // provide the order id
        params.oid = params.order_id;

        // attempt to reach the server
        axios.get(API_URL+'/api/email/order', { params })
            .then(function(res) {
                if (res.data.status == "success") {

                    dispatch(emailReceiptSuccess());
                    setTimeout(() => {
                        alert("Your receipt has been sent to your email!");
                    }, 100);
                }
                else {
                    dispatch(receiptError("We're sorry, but we were unable to send your receipt. Please try again in a moment or contact support if the issue persists."));
                }
            })
            .catch(function(err) {
                console.log(err);
                dispatch(receiptError("We're sorry, but we were unable to send your receipt. Please try again in a moment or contact support if the issue persists."));
            });
    };
}